import ContentApiSerializer from 'rise-ui/serializers/apis/rise-api/content.js';

export default class FieldSerializer extends ContentApiSerializer {
  extractAttributes(modelClass, resourceHash) {
    const attrs = super.extractAttributes(...arguments);
    const allowedValues = resourceHash.attributes?.settings?.allowed_values;
    if (allowedValues) {
      Object.assign(attrs, { allowedValues });
    }
    return attrs;
  }
}
